import { routes } from "common/routes/routes";
import { Permission } from "core/types/permission.enum";
import { Navigate } from "react-router-dom";

import { usePermissionsChecker } from "../core/auth/Permissions";

export const PermissionNavigate = () => {
  const hasPermissions = usePermissionsChecker();

  if (hasPermissions(Permission.ProsBpmWebAllowed)) {
    return <Navigate to={routes.bpMobileDashboard.basePath.path} />;
  }

  return <Navigate to={routes.settings.home.path} />;
};
